import { usePreparationMessageWorkspace } from "./usePreparationMessageWorkspace";
export function WorkflowComposerView({ check, workspace }: { check: Parameters<typeof usePreparationMessageWorkspace>[0]["check"]; workspace: ReturnType<typeof usePreparationMessageWorkspace> }) {
  const { type, setType, materialCode, setMaterialCode, requestedQuantity, setRequestedQuantity, message, setMessage, saving, isQuantityRequest, selectedItem, submit } = workspace;
  return (
    <div className="preparation-workflow">
      <div>
        <strong>Depo iletişimi</strong>
        <span>
          {check.messages.length
            ? `${check.messages.length} kayıt · Son: ${check.messages.at(-1)?.createdBy}`
            : "Henüz iletişim kaydı yok"}
        </span>
      </div>
      <select
        value={type}
        onChange={(event) => setType(event.target.value)}
        aria-label="İş akışı türü"
      >
        <option value="TRANSFER_REQUEST">Transfer ihtiyacı</option>
        <option value="MATERIAL_REQUEST">Malzeme talebi</option>
        <option value="CONFIRMATION_REQUEST">Karşı taraf teyidi</option>
        <option value="COMMENT">Açıklama</option>
      </select>
      <div className="preparation-workflow-fields">
        {isQuantityRequest ? (
          <>
            <select
              value={materialCode}
              onChange={(event) => setMaterialCode(event.target.value)}
              aria-label="Talep edilen malzeme"
            >
              {check.items.map((item) => (
                <option key={item.materialCode} value={item.materialCode}>
                  {item.materialCode} · {item.materialName}
                </option>
              ))}
            </select>
            <span>
              <input
                type="number"
                min="0"
                step="any"
                value={requestedQuantity}
                onChange={(event) => setRequestedQuantity(event.target.value)}
                placeholder="Miktar"
                aria-label="Talep miktarı"
              />
              <b>{selectedItem?.unit ?? ""}</b>
            </span>
          </>
        ) : null}
        <input
          value={message}
          maxLength={1000}
          onChange={(event) => setMessage(event.target.value)}
          placeholder="Problem, beklenen aksiyon veya açıklama"
          aria-label="Malzeme iş akışı açıklaması"
        />
      </div>
      <button
        type="button"
        disabled={saving || message.trim().length < 3}
        onClick={() => void submit()}
      >
        {saving ? "Kaydediliyor…" : "Kaydet ve izle"}
      </button>
    </div>
  );
}

export function WorkflowComposer(props: Parameters<typeof usePreparationMessageWorkspace>[0]) {
  const workspace = usePreparationMessageWorkspace(props);
  return <WorkflowComposerView check={props.check} workspace={workspace} />;
}
